import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import useAuth from "src/hooks/useAuth/useAuth";
import cmsClient from "src/services/cmsClient";

const downloadAllUsersReport = async ({
	formId,
	startDate,
	endDate
}: ExportCSVOptions) => {
	const url = "/observations/reports/all-users";

	const data = { form_id: formId, startDate, endDate };

	const response = await cmsClient.post(url, data);
	return response.data;
};

const useAllUsersReport = () => {
	const { user } = useAuth();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message={`A link to your export (All Users) has been generated. Check your mail inbox (${user?.emailAddress}) for the link.`}
			/>,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(downloadAllUsersReport, { onSuccess, onError });
	return mutation;
};

export default useAllUsersReport;
